// src/pages/actives/locations/ActiveLocations.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../../api/axios";
import Table from "../../../../components/Table";
import ActionButtons from "../../../../components/ActionButtons";
import { Plus } from "lucide-react";
import { toast } from "react-toastify";

function ActiveLocations() {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    fetchLocations();
  }, []);

  const fetchLocations = () => {
    api
      .get("/active-locations")
      .then((res) => setLocations(res.data))
      .catch(() => toast.error("Error al cargar ubicaciones", "error"));
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-md">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-3xl font-semibold text-gray-800">Ubicaciones de Activos</h2>
        <Link
          to="/actives/locations/create"
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow flex items-center gap-2 transition duration-300"
        >
          <Plus size={18} />
          Nueva Ubicación
        </Link>
      </div>

      <Table
        columns={[
          { label: "Nombre", key: "name", width: "w-1/2" },
          { label: "Descripción", key: "description", width: "w-1/2" },
        ]}
        data={locations}
        renderActions={(location) => (
          <ActionButtons
            editUrl={`/actives/locations/edit/${location.id}`}
            onDelete={() => location.id}
          />
        )}
      />
    </div>
  );
}

export default ActiveLocations;
